const travellerFactory = require('./traveller');

function index(travellers) {
    const that = {};

    const travellersList = Odigeo._.map(travellers, (traveller) => travellerFactory(traveller));

    that.getTraveller = function(index) {
        return travellersList[index];
    };

    that.getNumberOfTravellers = function() {
        return travellersList.length;
    };

    that.getTravellerList = function() {
        return Odigeo._.extend({}, travellersList);
    };

    that.getTotalBaggagesInArrival = function() {
        return Odigeo._.reduce(travellersList, (accumulator, traveller) => {
            return accumulator + traveller.getBaggagesInArrival();
        }, 0);
    };

    that.getTotalBaggagesInDeparture = function() {
        return Odigeo._.reduce(travellersList, (accumulator, traveller) => {
            return accumulator + traveller.getBaggagesInDeparture();
        }, 0);
    };

    return that;
}

module.exports = index;
